import { MapBounds } from "../models/map.bounds";
import { MapLatLng } from "../models/map.latlng";
import { MapMarker } from "../models/map.marker";
import { MapPolygon } from "../models/map.polygon";
import { ItemCluster } from "./item-cluster";

export class CellCluster {
    public map: any;
    public marker: MapMarker;
    public bounds: MapBounds;
    public oneItem?: ItemCluster;
    public numItems = 0;
    public poligon?: MapPolygon;
    public debug = false;

    constructor(map: any, bounds: MapBounds, debug: boolean) {
        this.map = map;
        this.bounds = bounds;
        this.debug = debug;
        this.marker = this.map.addMarker({
            dataModel: this,
            label: '' + this.numItems,
            content: '',
            position: new MapLatLng(bounds.swCorner.lat + ((bounds.neCorner.lat - bounds.swCorner.lat) / 2),
                bounds.swCorner.lng + ((bounds.neCorner.lng - bounds.swCorner.lng) / 2)),
            icon: 'assets/images/cluster/m1.png',
            zIndex: 100,
            drag: false,
            visible: false
        });
    }

    public setBounds(bounds: MapBounds) {
        this.bounds = bounds;
        if (this.numItems < 1) {
            this.marker.setPosition(new MapLatLng(bounds.swCorner.lat + ((bounds.neCorner.lat - bounds.swCorner.lat) / 2),
                bounds.swCorner.lng + ((bounds.neCorner.lng - bounds.swCorner.lng) / 2)));
        }
        // Sólo para ver la malla
        if (this.debug) {
            if (this.poligon) {
                this.map.removePolygon(this.poligon);
            }
            this.poligon = this.map.addPolygon({ fillOpacity: 0, weight: 0.1, strokeColor: '#ff0000', fillColor: '#ffffff' });
            this.map.addPolygonPoint(this.poligon, { position: bounds.swCorner });
            this.map.addPolygonPoint(this.poligon, { position: new MapLatLng(bounds.neCorner.lat, bounds.swCorner.lng) });
            this.map.addPolygonPoint(this.poligon, { position: bounds.neCorner });
            this.map.addPolygonPoint(this.poligon, { position: new MapLatLng(bounds.swCorner.lat, bounds.neCorner.lng) });
        }
    }

    public setMarkerPos(lat: number, lng: number) {
        this.marker.setPosition(new MapLatLng(lat, lng));
    }
}